@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">{{ pageTitle }}</h3>
  </div>
</div>

<div class="questions-container">
  <!-- Tabs Section -->
  <div class="tabs-header">
    <div class="tabs-list">
      <button 
        class="tab-item" 
        [class.active]="selectedTab === 'all'"
        (click)="selectTab('all')">
        <span class="tab-label">الكل</span>
        <span class="tab-count">({{ tabCounts.all }})</span>
      </button>
      <button 
        class="tab-item" 
        [class.active]="selectedTab === 'open'"
        (click)="selectTab('open')">
        <span class="tab-label">مفتوح</span>
        <span class="tab-count">({{ tabCounts.open }})</span>
      </button>
      <button 
        class="tab-item" 
        [class.active]="selectedTab === 'needsReview'"
        (click)="selectTab('needsReview')">
        <span class="tab-label">تحتاج مراجعة</span>
        <span class="tab-count">({{ tabCounts.needsReview }})</span>
      </button>
      <button 
        class="tab-item" 
        [class.active]="selectedTab === 'closed'"
        (click)="selectTab('closed')">
        <span class="tab-label">مغلق</span>
        <span class="tab-count">({{ tabCounts.closed }})</span>
      </button>
    </div>
  </div>

  <!-- Table Section -->
  @if (questions && questions.length > 0) {
    <div class="questions-table-wrapper">
      <div class="table-responsive">
        <table class="questions-table">
          <thead>
            <tr>
              <th class="col-reference">رقم السوال</th>
              <th class="col-question-text">نص السؤال</th>
              <th class="col-client">العميل</th>
              <th class="col-specialization">التخصصات</th>
              <th class="col-status">الحالة</th>
              <th class="col-answers">الإجابات</th>
              <th class="col-create-date">تاريخ الإنشاء</th>
              <th class="col-close-date">تاريخ الإغلاق</th>
              <th class="col-actions">تعديل</th>
            </tr>
          </thead>
          <tbody>
            @for (
              question of questions | paginate: config;
              track question.id; let index = $index; let isEven = $even
            ) {
              <tr [class.even-row]="isEven" [class.odd-row]="!isEven">
                <td class="col-reference">Q-{{ question.id }}</td>
                <td class="col-question-text">{{ question.content }}</td>
                <td class="col-client">
                  <a [href]="'/pages/customers/customer-profile/' + question.client?.id" target="_blank" class="client-link">{{ getClientName(question) }}</a>
                </td>
                <td class="col-specialization">{{ getSpecialization(question) }}</td>
                <td class="col-status">
                  <span class="status-badge" [ngClass]="getStatusClass(question.status)">
                    {{ getStatusText(question.status) }}
                  </span>
                </td>
                <td class="col-answers">{{ question.answers_count || 0 }}</td>
                <td class="col-create-date">{{ formatDate(question.created_at) }}</td>
                <td class="col-close-date">{{ formatDate(question.closed_at) }}</td>
                <td class="col-actions">
                  <button class="btn-edit" (click)="editQuestion(question.id)">
                    <span class="edit-text">تعديل</span>
                    <img src="assets/images/svg/edit-icon.svg" alt="تعديل" class="edit-icon" />
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  } @else if (!spinner) {
    <div class="no-data">
      <p>لا توجد بيانات</p>
    </div>
  }
</div>

@if (questions && questions.length > 0) {
  <ayen-pagination
    (pageData)="pageChanged($event)"
    (pageSize)="pageSizeChanged($event)"
    [totalCount]="config.totalItems"
    [id]="'questionsPagination'"
    [itemsPerPage]="config.itemsPerPage"
    (pageChange)="pageChanged($event)"
    [currentPage]="config.currentPage"
    [pageTitle]="pageTitle"
  >
  </ayen-pagination>
}
